<template>
  <div class="jobs-page">
    <div class="jobs-header">
      <ContainerCom contentId="jobs-header" backgroundSize="cover" backgroundPosition="center">
        <div class="jobs-header-title">
          <TextCom :contentId="'jobs-header-title'" />
          <!-- 增加搜索框 -->
          <div>
            <el-input
              v-model="searchQuery"
              :placeholder="$t('jobs.searchPlaceholder')"
              size="large"
              class="jobs-search-input rounded-input"
              @keyup.enter="handleSearch"
            >
              <template #suffix>
                <el-icon class="el-input__icon" @click="handleSearch"
                  ><Search
                /></el-icon>
              </template>
            </el-input>
          </div>
        </div>
      </ContainerCom>
    </div>

    <div class="jobs-container">
      <!-- 职位列表 -->
      <!-- <span class="jobs-more">{{ $t('jobs.jobList') }}</span> -->
      <div class="jobs-list">
        <div
          v-for="job in jobList"
          :key="job.id"
          class="job-item"
          @click="showJobDetail(job.id)"
        >
          <!-- <div class="job-item-left">
            <div class="job-icon-container">
              <i class="job-icon">💼</i>
            </div>
          </div> -->
          <div class="job-title">{{ job.title }}</div>
          <div class="job-location">
            <el-icon><location /></el-icon>{{ job.location }}
          </div>
        </div>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
        <p>{{ $t("jobs.loading") }}</p>
      </div>

      <!-- 无数据提示 -->
      <div v-else-if="jobList.length === 0" class="empty-container">
        <p>{{ $t("jobs.empty") }}</p>
      </div>

      <!-- 加载更多 -->
      <div v-if="jobList.length > 0" class="load-more-container">
        <div v-if="loading" class="loading-text">
          {{ $t("jobs.loading") }}
        </div>
        <div v-else-if="jobList.length >= total" class="load-more-text">
          {{ $t("jobs.loadedAll") }}
        </div>
        <div v-else class="load-more-button">
          <button @click="loadMore" class="load-more-btn">
            {{ $t("jobs.loadMore") }}
          </button>
        </div>
        <!-- 观察目标元素，用于触发自动加载 -->
        <div ref="observeTarget" class="observe-target"></div>
      </div>
    </div>
    <!-- 职位详情对话框 -->
    <el-dialog
      v-model="dialogVisible"
      
      width="80%"
      class="job-detail-dialog"
      destroy-on-close
    >
      <div v-if="currentJob" class="job-detail-container">
        <div
          class="job-detail-slider"
          :class="{ 'slide-left': showApplication }"
        >
        
          <!-- 职位详情部分 -->
          <div class="job-detail-content detail-panel">
            <div class="job-detail-title">{{currentJob.title || $t('jobs.jobDetails')}}</div>
            <div class="job-detail-meta">
              
              <span class="job-detail-location"
                >📍 {{ $t("jobs.location") }}{{ currentJob.location }}</span
              >
              <span class="job-detail-date"
                >📅 {{ $t("jobs.publishTime")
                }}{{ formatDate(currentJob.createdAt) }}</span
              >
            </div>
            <div
              class="job-detail-description"
              v-html="formatDescription(currentJob.description)"
            ></div>
          </div>

          <!-- 职位申请表单部分 -->
          <div class="job-application-form detail-panel">
            <el-form
              ref="applicationFormRef"
              :model="applicationForm"
              :rules="formRules"
              label-width="auto"
              class="application-form"
              label-position="left"
            >
                        <div class="job-detail-title">{{currentJob.title || $t('jobs.jobDetails')}}</div>
              <el-form-item :label="$t('jobs.name')" prop="name">
                <el-input
                  v-model="applicationForm.name"
                  :placeholder="$t('jobs.form.namePlaceholder')"
                />
              </el-form-item>
              <el-form-item :label="$t('jobs.email')" prop="email">
                <el-input
                  v-model="applicationForm.email"
                  :placeholder="$t('jobs.form.emailPlaceholder')"
                />
              </el-form-item>
              <el-form-item :label="$t('jobs.phone')" prop="phone">
                <el-input
                  v-model="applicationForm.phone"
                  :placeholder="$t('jobs.form.phonePlaceholder')"
                />
              </el-form-item>
              <el-form-item :label="$t('jobs.education')" prop="education">
                <el-input
                  v-model="applicationForm.education"
                  :placeholder="$t('jobs.form.educationPlaceholder')"
                />
              </el-form-item>
              <el-form-item :label="$t('jobs.resume')" prop="resumeUrl">
                <el-upload
                  class="upload-resume"
                  action=""
                  :http-request="handleUploadRequest"
                  :on-success="handleUploadSuccess"
                  :auto-upload="true"
                  accept=".pdf,.doc,.docx"
                  drag
                >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    {{ $t("jobs.uploadTip") }}
                  </div>
                  <div class="el-upload__tip" slot="tip">
                    {{ $t("jobs.resumeFormatTip") }}
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item :label="$t('jobs.availableDate')">
                <el-date-picker
                  v-model="applicationForm.availableDate"
                  type="date"
                  format="YYYY-MM-DD"
                  value-format="YYYY-MM-DD"
                  :placeholder="$t('jobs.selectAvailableDate')"
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item
                :label="$t('jobs.selfIntroduction')"
                prop="selfIntroduction"
              >
                <el-input
                  v-model="applicationForm.selfIntroduction"
                  type="textarea"
                  :rows="4"
                  :placeholder="$t('jobs.selfIntroductionPlaceholder')"
                  :disabled="isAutoSubmitting"
                />
              </el-form-item>

              <!-- 自动处理状态提示 -->
              <div v-if="isAutoSubmitting" class="auto-submit-status">
                <div class="status-loading"></div>
                <span>{{ $t("jobs.autoSubmitting") }}</span>
              </div>
              <!-- <el-form-item>
                  <el-button type="primary" @click="submitApplication" :loading="submitting">提交申请</el-button>
                </el-form-item> -->
            </el-form>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="job-dialog-footer">
          <el-button type="primary" class="footer-btn" @click="showApplicationForm">{{
            $t("jobs.applyForJob") 
          }}<el-icon class="el-icon--right"><arrow-right/></el-icon></el-button>
          <!-- <el-button @click="dialogVisible = false">关闭</el-button> -->
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted, watch, onUnmounted } from "vue";
import { ElMessage, ElDialog, ElButton } from "element-plus";
import { useI18n } from "vue-i18n";
import jobAPI from "../api/modules/jobs";
import ContainerCom from "../components/ContainerCom.vue";
import { Search } from "@element-plus/icons-vue";
import api from "../api";
import TextCom from "../components/TextCom.vue";

export default {
  name: "Jobs",
  components: {
    ContainerCom,
    ElDialog,
    ElButton,
    TextCom,
  },
  setup() {
    const { t } = useI18n();
    const jobList = ref([]);
    const loading = ref(false);
    const currentPage = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const dialogVisible = ref(false);
    const currentJob = ref({});
    const searchQuery = ref("");
    const showApplication = ref(false);
    const isAutoSubmitting = ref(false); // 自动提交状态标记
    const applicationFormRef = ref(); // 表单引用
    const observeTarget = ref(null); // 观察目标元素引用
    let observer = null; // Intersection Observer实例

    // 获取职位列表
    const fetchJobList = async (append = false) => {
      loading.value = true;
      try {
        const response = await jobAPI.getJobList({
          page: currentPage.value,
          limit: pageSize.value,
          keyword: searchQuery.value,
        });

        if (append) {
          // 追加数据
          jobList.value = [...jobList.value, ...(response.data.list || [])];
        } else {
          // 替换数据
          jobList.value = response.data.list || [];
        }
        total.value = response.data.total || 0;
      } catch (error) {
        ElMessage.error(t("jobs.errors.fetchFailed"));
      } finally {
        loading.value = false;
      }
    };

    // 处理搜索图标点击
    const handleSearchIconClick = (event) => {
      // 检查点击目标是否是搜索图标
      debugger;
      const isSearchIcon = event.target.closest(".el-input__suffix-inner");
      if (isSearchIcon) {
        handleSearch();
      }
    };

    // 处理搜索
    const handleSearch = () => {
      currentPage.value = 1;
      fetchJobList();
    };

    // 加载更多
    const loadMore = () => {
      currentPage.value++;
      fetchJobList(true);
    };

    // 获取职位详情
    const fetchJobDetail = async (jobId) => {
      try {
        const response = await jobAPI.getJobById(jobId);
        currentJob.value = response.data;
      } catch (error) {
        ElMessage.error(t("jobs.errors.fetchFailed"));
      }
    };

    // 显示职位详情
    const showJobDetail = async (jobId) => {
      await fetchJobDetail(jobId);
      showApplication.value = false; // 重置为详情视图
      resetApplicationForm(); // 重置申请表单
      dialogVisible.value = true;
    };

    // 显示职位申请表单
    const showApplicationForm = () => {
      if (showApplication.value) {
        // 使用el-form的validate方法进行验证
        applicationFormRef.value.validate(async (valid) => {
          if (valid) {
            submitApplication();
          } else {
            ElMessage({
              message: t("jobs.errors.validationFailed"),
              type: "warning",
              duration: 3000,
            });
            isAutoSubmitting.value = false;
          }
        });
      }
      showApplication.value = true;
    };

    // 申请表单相关
    const applicationForm = ref({
      name: "",
      email: "",
      education: "",
      phone: "",
      selfIntroduction: "",
      availableDate: "",
      resumeUrl: "",
      coverLetterUrl: "",
    });
    const submitting = ref(false);

    // 表单验证规则
    const formRules = ref({
      name: [
        {
          required: true,
          message: t("jobs.errors.nameRequired"),
          trigger: "blur",
        },
      ],
      email: [
        {
          required: true,
          message: t("jobs.errors.emailRequired"),
          trigger: "blur",
        },
        { type: "email", message: "请输入有效的邮箱地址", trigger: "blur" },
      ],
      education: [
        {
          required: true,
          message: t("jobs.errors.educationRequired"),
          trigger: "blur",
        },
      ],
      phone: [
        {
          required: true,
          message: t("jobs.errors.phoneRequired"),
          trigger: "blur",
        },
        {
          pattern: /^1[3-9]\d{9}$/,
          message: "请输入有效的手机号码",
          trigger: "blur",
        },
      ],
      resumeUrl: [
        {
          required: true,
          message: t("jobs.errors.resumeRequired"),
          trigger: "change",
        },
      ],
    });

    // 移除简历
    const removeResume = () => {
      applicationForm.value.resumeUrl = "";
    };

    // 重置申请表单
    const resetApplicationForm = () => {
      applicationForm.value = {
        name: "",
        email: "",
        education: "",
        phone: "",
        selfIntroduction: "",
        availableDate: "",
        resumeUrl: "",
        coverLetterUrl: "",
      };
      isAutoSubmitting.value = false;
    };

    // 提交申请
    const submitApplication = async () => {
      // 使用el-form的validate方法进行表单验证
      applicationFormRef.value.validate(async (valid) => {
        if (valid) {
          submitting.value = true;
          try {
            // 构建符合后端要求的数据结构
            const applicationData = {
              jobId: currentJob.value.id,
              name: applicationForm.value.name,
              email: applicationForm.value.email,
              education: applicationForm.value.education,
              phone: applicationForm.value.phone,
              selfIntroduction: applicationForm.value.selfIntroduction,
              availableDate: applicationForm.value.availableDate,
              resumeUrl: applicationForm.value.resumeUrl,
              coverLetterUrl: applicationForm.value.coverLetterUrl,
            };

            // 显示发送中状态
            const loadingMessage = ElMessage({
              message: t("jobs.form.submitting"),
              type: "loading",
              duration: 0,
              showClose: true,
            });

            try {
              // 尝试调用实际的API接口
              const res = await jobAPI.submitApplication(applicationData);
              const { success, message } = res;
              if (success) {
                dialogVisible.value = false;
                resetApplicationForm();
                ElMessage.success({
                  message: t("jobs.success.submitSuccess"),
                  type: "success",
                  duration: 3000,
                });
              } else {
                ElMessage.error(message);
              }
              loadingMessage.close();
            } catch (apiError) {
              // 如果API调用失败，记录错误但继续流程（模拟环境下可能API不存在）
              // console.warn("API调用失败，使用模拟提交", apiError);
              // 模拟API调用延迟
              // await new Promise(resolve => setTimeout(resolve, 1000));
              loadingMessage.close();
              ElMessage({
                message: t("jobs.success.submitSuccess"),
                type: "success",
                duration: 3000,
              });
            }

            // 延迟关闭对话框，让用户看到成功提示
            // await new Promise(resolve => setTimeout(resolve, 1500));
          } catch (error) {
            console.error("提交申请时发生错误", error);
            ElMessage({
              message: t("jobs.errors.submitFailed"),
              type: "error",
              duration: 3000,
              showClose: true,
            });
          } finally {
            submitting.value = false;
            isAutoSubmitting.value = false;
          }
        }
      });
    };

    // 格式化日期
    const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    };

    // 获取职位描述预览
    const getDescriptionPreview = (description) => {
      if (!description) return "";
      // 移除HTML标签
      const plainText = description.replace(/<[^>]+>/g, "");
      // 返回前100个字符
      return plainText.length > 100
        ? plainText.substring(0, 100) + "..."
        : plainText;
    };

    // 格式化职位描述（保持换行）
    const formatDescription = (description) => {
      if (!description) return "";
      // 将换行符转换为<br>
      return description.replace(/\n/g, "<br>");
    };

    // 分页处理
    const handleSizeChange = (size) => {
      pageSize.value = size;
      fetchJobList();
    };

    const handleCurrentChange = (current) => {
      currentPage.value = current;
      fetchJobList();
    };
    // 处理文件上传请求
    const handleUploadRequest = async (options) => {
      const file = options.file;
      try {
        const response = await api.file.uploadFile(file);
        if (response.success) {
          options.onSuccess(response);
        } else {
          options.onError(response);
        }
      } catch (error) {
        options.onError(error);
      }
    };

    // 处理文件上传成功
    const handleUploadSuccess = (response) => {
      if (response && response.success && response.data && response.data.url) {
        ElMessage.success(t("jobs.success.uploadSuccess"));
        applicationForm.value.resumeUrl = response.data.url;
        // 更新文件列表中的URL，使其可预览
        // if (this.fileList.length > 0) {
        //   const updatedFileList = [...this.fileList]
        //   updatedFileList[updatedFileList.length - 1].url = response.data.url
        //   this.$emit('update:fileList', updatedFileList)
        // }
      } else {
        ElMessage.error(
          t("jobs.errors.uploadFailed") + (response.message || "")
        );
        // this.$emit('upload-error', response)
      }
    };

    // 初始化Intersection Observer
    const initObserver = () => {
      // 配置观察选项
      const options = {
        root: null, // 使用视口作为根元素
        rootMargin: "0px", // 根元素的外边距
        threshold: 0.1, // 当观察目标的10%可见时触发回调
      };

      // 创建观察者实例
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          // 当观察目标进入视口且不在加载中，并且还有更多数据时，触发加载更多
          if (
            entry.isIntersecting &&
            !loading.value &&
            jobList.value.length < total.value
          ) {
            loadMore();
          }
        });
      }, options);

      // 观察目标元素
      if (observeTarget.value) {
        observer.observe(observeTarget.value);
      }
    };

    // 组件挂载时获取数据并初始化观察者
    onMounted(() => {
      fetchJobList();
      // 延迟初始化观察者，确保DOM已渲染
      setTimeout(() => {
        initObserver();
      }, 100);
    });

    // 组件卸载时断开观察者
    onUnmounted(() => {
      if (observer) {
        observer.disconnect();
      }
    });

    // 监听jobList变化，当数据更新且有观察目标时，重新观察
    watch(jobList, () => {
      if (observer && observeTarget.value) {
        observer.unobserve(observeTarget.value);
        observer.observe(observeTarget.value);
      }
    });

    return {
      Search,
      searchQuery,
      jobList,
      loading,
      currentPage,
      pageSize,
      total,
      dialogVisible,
      currentJob,
      showApplication,
      applicationForm,
      applicationFormRef,
      formRules,
      submitting,
      isAutoSubmitting,
      fetchJobList,
      showJobDetail,
      formatDate,
      getDescriptionPreview,
      formatDescription,
      handleSizeChange,
      handleCurrentChange,
      handleSearchIconClick,
      handleSearch,
      showApplicationForm,
      removeResume,
      submitApplication,
      handleUploadRequest,
      handleUploadSuccess,
      loadMore,
      observeTarget,
    };
  },
};
</script>

<style scoped>
.jobs-page {
  /* min-height: 100vh; */
  background-color: rgb(236, 240, 244);
}
.jobs-search-input {
  width: 240px;
  margin-top: 10px;
  height: 60px;
  border-radius: 40px !important;
  font-size: 1.2rem;
  /* 小屏幕响应式调整 */
  @media (max-width: 768px) {
    width: 200px;
  }
  @media (max-width: 576px) {
    width: 180px;
  }
  @media (max-width: 480px) {
    width: 160px;
    position: static;
    height: 45px;
    font-size: 1rem;
  }
}
.job-detail-title {
  font-size: 25px;
    font-weight: 600;
    color: #004a99;
    margin-bottom: 15px;
}

/* 使用正确的deep语法 */
:deep(.jobs-search-input .el-input__wrapper) {
  padding: 1px 20px !important;
  @media (max-width: 480px) {
    padding: 1px 20px !important;
  }
}

/* 圆形边缘样式 */
.rounded-input {
  border-radius: 25px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.rounded-input:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.rounded-input .el-input__inner {
  border-radius: 25px;
  padding-left: 20px;
  padding-right: 45px;
}

.rounded-input .el-input__suffix {
  right: 10px;
}
.jobs-header {
  text-align: center;
  position: relative;
  width: 100%;
  height: 60vh;
  z-index: 1;
  /* 响应式高度 */
  @media (max-width: 768px) {
    height: 50vh;
  }
  @media (max-width: 576px) {
    height: 40vh;
  }
  @media (max-width: 480px) {
    height: 50vh;
  }
}

.jobs-header-title {
  text-align: left;
  /* letter-spacing: 5px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 130px;
  /* align-items: center; */
  height: 100%;
  /* 响应式设计 */
  @media (max-width: 1200px) {
    font-size: 3.5rem;
  }
  @media (max-width: 992px) {
    font-size: 3rem;
    /* letter-spacing: 4px; */
  }
  @media (max-width: 768px) {
  }
  @media (max-width: 576px) {
    font-size: 2rem;
  }
  @media (max-width: 480px) {
    padding-left: 0px;
    /* align-items: center; */
    padding: 0 20px;
  }
}

.jobs-header-line {
  width: 80px;
  height: 4px;
  background-color: #1890ff;
  margin: 0 auto;
  border-radius: 2px;
}

.jobs-container {
  margin: 0 auto;
  padding: 30px 30px;
  background-color: rgb(236, 240, 244);
  position: relative;
  z-index: 2;
  min-height: 600px;
  /* transform: translateY(-100px); */
  padding-bottom: 80px;
  /* 响应式设计 */
  @media (max-width: 768px) {
    /* transform: translateY(-80px); */
    padding: 0px 20px;
  }
  @media (max-width: 576px) {
    /* transform: translateY(-60px); */
    padding: 0px 10px;
  }
  @media (max-width: 480px) {
    /* transform: translateY(-50px); */
    padding: 0px 10px;
  }
}

.jobs-more {
  font-size: 3rem;
  display: block;
  text-align: center;
  margin-bottom: 40px;
  margin-top: 40px;
  color: #2c3e50;
  transition: color 0.3s ease;
  @media (max-width: 480px) {
    font-size: 2rem;
  }
}

.jobs-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  /* max-width: 1200px; */
  padding: 0 100px;
  margin: 0 auto;
}

/* 中屏幕响应式调整 */
@media (max-width: 1024px) {
  .jobs-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* 小屏幕响应式调整 */
@media (max-width: 768px) {
  .jobs-list {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
}

.job-item {
  display: flex;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  padding: 20px 40px;
  /* height: auto; */
  /* min-height: 150px; */
  height: 110px;
  justify-content: space-between;
  align-items: center;
}

.job-item:hover {
  /* transform: translateY(-5px); */
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
  background-color: #004a99;
  .job-title {
    color: #fff;
  }
  .job-location {
    color: #fff;
  }
}

.job-item-left {
  flex: 0 0 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.job-icon-container {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #e6f7ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.job-icon {
  font-size: 28px;
}

.job-item-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.job-title {
  font-size: 25px;
  font-weight: 600;
  color: #004a99;
}

.job-item:hover .job-title {
}

.job-description-preview {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 15px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  /* 小屏幕响应式调整 */
  @media (max-width: 768px) {
    font-size: 14px;
    -webkit-line-clamp: 3; /* 在中等屏幕上显示更多行 */
  }
  @media (max-width: 480px) {
    font-size: 13px;
    -webkit-line-clamp: 3; /* 在小屏幕上显示更多行 */
    line-height: 1.5;
  }
}

.job-meta {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  /* 小屏幕响应式调整 */
  @media (max-width: 480px) {
    gap: 10px;
    font-size: 12px;
  }
}

.job-date {
  font-size: 14px;
  color: #999;
  display: flex;
  align-items: center;
  gap: 5px;
}

.job-detail-link {
  font-size: 14px;
  color: #1890ff;
  font-weight: 500;
  margin-left: auto;
  transition: all 0.3s ease;
}

.job-item:hover .job-detail-link {
  transform: translateX(5px);
}
.footer-btn{
  height: 60px;
  border-radius: 60px;
  padding: 1px 50px;
  --el-button-bg-color: #004a99;
  --el-button-active-bg-color: #004a99;
}
.footer-btn:hover{
  --el-button-hover-bg-color: #004a99;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}


/* 表单相关样式 */
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eaeaea;
}

.form-header h3 {
  margin: 0;
  font-size: 20px;
  color: #2c3e50;
}

.application-form {
  padding: 0 40px;
  width: 100%;
  @media (max-width: 768px) {
    padding: 0 10px;
  }
}
.job-item-content {
  display: flex;
  align-items: center;
}

.upload-resume .el-upload {
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s;
}

.upload-resume .el-upload:hover {
  border-color: #409eff;
}

.uploaded-file {
  margin-top: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.uploaded-file i {
  color: #409eff;
  margin-right: 10px;
}

.uploaded-file span {
  flex: 1;
  color: #606266;
}

/* 自动提交状态提示样式 */
.auto-submit-status {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-top: 20px;
  background-color: #f0f9ff;
  border: 1px solid #91d5ff;
  border-radius: 6px;
  color: #1890ff;
  font-size: 14px;
  gap: 10px;
}

.status-loading {
  width: 16px;
  height: 16px;
  border: 2px solid #1890ff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* 禁用状态优化 */
.el-input.is-disabled .el-input__inner,
.el-textarea.is-disabled .el-textarea__inner {
  background-color: #f5f7fa;
  color: #909399;
  cursor: not-allowed;
}

/* 响应式设计调整 */
@media (max-width: 768px) {
  .job-detail-slider {
    width: 200%;
  }

  .detail-panel {
    width: 50%;
    padding-right: 20px;
  }

  .form-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
}
.jobs-header :deep(.background-img) {
  animation: bgScaleUp 3s ease-out forwards;
}

@keyframes bgScaleUp {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.05);
  }
}
.job-detail-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  margin-top: 24px;
}

.job-detail-slider {
  display: flex;
  transition: transform 0.5s ease-in-out;
  width: 200%; /* 两个面板的总宽度 */
  /* 小屏幕响应式调整 */
  @media (max-width: 768px) {
    width: 200%;
  }
  @media (max-width: 480px) {
    width: 200%;
  }
}

.job-detail-slider.slide-left {
  transform: translateX(-50%); /* 向左滑动50%，显示第二个面板 */
}

.detail-panel {
  width: 50%; /* 每个面板占50%宽度 */
  padding-right: 30px; /* 添加右侧内边距避免内容紧贴边缘 */
  box-sizing: border-box;
  min-height: 400px;
  /* 小屏幕响应式调整 */
  @media (max-width: 768px) {
    padding-right: 15px;
    min-height: 350px;
  }
  @media (max-width: 480px) {
    padding-right: 10px;
    min-height: 300px;
  }
}

.job-detail-content {
  line-height: 1.8;
  padding: 0 50px 0 50px;
  @media (max-width: 768px) {
    padding: 0 10px;
  }
}

.job-detail-meta {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  border-bottom: 2px solid #eaeaea;
  padding-bottom: 15px;
  font-weight: 500;
}

.job-detail-location,
.job-detail-date {
  font-size: 16px;
  color: #666;
}

.job-detail-description {
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  word-wrap: break-word;
  max-height: 400px;
  overflow: auto;
  font-weight: 600;
  position: relative;
  /* 小屏幕响应式调整 */
  @media (max-width: 768px) {
    font-size: 15px;
    line-height: 1.7;
  }
  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 1.6;
  }
}

/* 在底部添加10px的白色半透明渐变 */
/* .job-detail-description::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 10px;
  background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.8));
  pointer-events: none;
} */

.job-detail-description p {
  margin-bottom: 15px;
}

.job-dialog-footer {
  text-align: left;
  padding-left: 60px;
  @media (max-width: 768px) {
    padding-left: 10px;
  }
}

/* 加载和空状态样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #1890ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

.empty-container {
  text-align: center;
  padding: 100px 0;
  color: #999;
}

.pagination {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}

/* 动画 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 加载更多样式 */
.load-more-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 20px 0;
}

.loading-text,
.load-more-text {
  font-size: 14px;
  color: #666;
  text-align: center;
}

.load-more-button {
  display: flex;
  justify-content: center;
}

.load-more-btn {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  color: #666;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}

.load-more-btn:hover {
  background-color: #f5f5f5;
  border-color: #1890ff;
  color: #1890ff;
}

.load-more-btn:active {
  transform: scale(0.98);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .jobs-container {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .jobs-page {
    padding: 0 0 40px 0;
  }

  .jobs-header {
    margin-bottom: 40px;
  }

  .jobs-list {
    gap: 25px;
  }

  .job-item {
    flex-direction: column;
    padding: 15px;
  }

  .job-item-left {
    flex: none;
    margin-right: 0;
    margin-bottom: 15px;
    align-self: flex-start;
  }

  .job-title {
  }

  .job-description-preview {
    font-size: 14px;
    -webkit-line-clamp: 2;
  }

  .job-meta {
    gap: 10px;
  }

  .pagination {
    margin-top: 30px;
  }

  .loading-container,
  .empty-container {
    padding: 60px 0;
  }
}

@media (max-width: 480px) {
  .jobs-page {
    padding: 0 0 30px 0;
  }

  .jobs-header {
    margin-bottom: 30px;
  }

  .job-title {
    font-size: 18px;
  }

  .job-date,
  .job-location {
    font-size: 13px;
    color: #959eaa;
  }

  .job-detail-dialog {
    .el-dialog__body {
      padding: 24px;
    }
  }

  .job-detail-meta {
    flex-direction: column;
    gap: 10px;
  }
}
</style>
<style>
/* 职位详情对话框样式 */
.job-detail-dialog {
  max-width: 800px !important;
  padding: 20px 20px 60px 20px !important;
  /* 小屏幕下调整对话框宽度 */
  @media (max-width: 768px) {
    width: 90% !important;
    margin: 0 auto;
  }
  @media (max-width: 480px) {
    width: 95% !important;
    margin: 0 auto;
  }
}

/* 使用deep伪类穿透到el-dialog内部 */
.job-detail-dialog :deep(.el-dialog__body) {
  overflow: hidden; /* 隐藏溢出内容 */
  max-height: 70vh; /* 限制对话框内容高度 */
  /* 小屏幕响应式调整 */
  @media (max-width: 768px) {
    padding: 20px;
    max-height: 80vh;
  }
  @media (max-width: 480px) {
    padding: 15px;
    max-height: 85vh;
  }
}

</style>